{
  "Approve": "Approuver",
  "DeleteReminder": "Supprimer le rappel",
  "DismissAlert": "Ignorer",
  "DismissReminder": "Rejeter le rappel",
  "EditReminder": "Modifier le rappel",
  "High": "Élevé",
  "Reject": "Rejeter",
  "RemindMe15Min": "Me le rappeler dans 15 minutes",
  "RemindMe5Min": "Me le rappeler dans 5 minutes",
  "RemindMe60Min": "Me le rappeler dans une heure",
  "RemindMeTomorrow": "Me le rappeler demain",
  "Snooze": "Me le rappeler",
  "markAsRead": "Marquer comme lu",
  "markAsUnread": "Marquer comme non lu"
}
